import { dispatch, regEventDb, regEventFx } from 'nike-re-framejs';
import history from './history';
import { defaultMiddlewares } from '@/common/util';
import { compile } from 'path-to-regexp';
import { setHeaderTitle } from '@/ui/handlers';
import { applyQueryParameter, resetQueryParameter } from './QueryParamRoute';
import { CURRENT_PAGE } from 'nike-ui/src/common/routing';
import { HOME } from '@/routing/routes';
import { isInSameNavigationGroup } from '@/routing/route-groups';
import { responsiveGetScrollTop } from '@/responsive';

regEventDb('setRouteAndPageTitle', defaultMiddlewares, (db, [route, title]) => {
    return db.setIn(['route'], route).update(setHeaderTitle(title));
});

function performNavigation(db, sync, targetRoute, params, searchParams, state, allowReplace = true) {
    if (!targetRoute) throw new Error('navigation: Undefined targetRoute. Check circular dependency?');
    const currentRoute = db.getIn(['route']);
    if (targetRoute === CURRENT_PAGE) {
        targetRoute = currentRoute;
    }
    const pathname = decodeURIComponent(compile(targetRoute.path)(params));
    const search = resetQueryParameter(searchParams);

    if (pathname !== history.location.pathname || search !== history.location.search) {
        function changeAction() {
            const historyData = { pathname, search, state: addMetaToState(state) };
            if (isInSameNavigationGroup(currentRoute, targetRoute) && allowReplace) {
                history.replace(historyData);
            } else {
                history.push(historyData);
            }
        }
        if (sync) {
            changeAction();
        } else {
            setTimeout(changeAction, 0);
        }
    }
    return db.setIn(['route'], targetRoute);
}

regEventFx('navigate', defaultMiddlewares, ({ db }, [targetRoute, params, searchParams, state, allowReplace]) => {
    responsiveGetScrollTop();
    return {
        db: performNavigation(db, false, targetRoute, params, searchParams, state, allowReplace)
    };
});

regEventDb('page_change_param', defaultMiddlewares, (db, [searchParams, state, replace = false]) => {
    setTimeout(() => {
        const [search, alreadyApplied] = applyQueryParameter(history.location, searchParams);
        const pathname = history.location.pathname;
        if (!alreadyApplied) {
            const location = { pathname, search, state: addMetaToState(state) };
            if (replace) {
                return history.replace(location);
            } else {
                return history.push(location);
            }
        }
    }, 0);
    return db;
});

regEventFx('navigateSync', defaultMiddlewares, ({ db }, [targetRoute, params, searchParams, state]) => {
    responsiveGetScrollTop();
    return {
        db: performNavigation(db, true, targetRoute, params, searchParams, state)
    };
});

regEventDb('page_replace', defaultMiddlewares, (db, [route, params, state]) => {
    const pathname = decodeURIComponent(compile(route.path)(params));
    setTimeout(() => history.replace(pathname, addMetaToState(state)));
    return db;
});

//sluzi na udrziavanie informacii o predchadzajucej stranke, kvoli funkcionalite back buttonu
const addMetaToState = (state = {}) => Object.assign({ fromApp: true }, state);

regEventDb('history_back', defaultMiddlewares, (db, [defaultRoute = HOME, params]) => {
    // obsluha historyBac
    if (!history.location.state || !history.location.state.fromApp) {
        dispatch(['page_replace', defaultRoute, params, { fromApp: false }]);
    } else {
        history.goBack();
    }

    return db;
});
